import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/components/customFilterStyle';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { translate } from 'components/Translation';
import classNames from 'classnames';
import Element from 'components/CustomFilter/Element';

// @ts-ignore
const useStyles = makeStyles(styles);

type ElementType = 'multiple' | 'one';

interface IElementItem {
	title: string;
	value: string;
	show?: React.ReactElement;
}

interface IAccordionElementProps {
	elements: IElementItem[];
	checked: string[];
	onChange: (e: any) => void;
	type: ElementType;
}

const AccordionElement = ({ elements, checked, onChange, type = 'one' }: IAccordionElementProps) => {
	const classes = useStyles();
	return (
		<div className={classes.accordionElementContainer}>
			<ConditionalRender show={elements.length > 5}>
				<div className={classes.accordionElement}>
					<Element
						all
						title={translate('all')}
						value="all"
						elements={elements}
						checked={checked}
						onChange={onChange}
						type={type}
					/>
				</div>
			</ConditionalRender>
			{elements.map(({ title, value, show }) => (
				<span key={value}>
					<div className={classes.accordionElement}>
						<Element
							value={value}
							checked={checked}
							onChange={onChange}
							type={type}
							title={title}
							elements={[]}
						/>
					</div>
					<div className={classNames(classes.accordionElementLabel, classes.showElement)}>
						{!!show && checked.includes(value) && show}
					</div>
				</span>
			))}
		</div>
	);
};

export default memo(AccordionElement);
